import React, { ReactElement } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { DashboardNavIcon, AuthActionIcon, ShopNavIcon, SurveysNavIcon, TheezyIcon } from '../icons';
import { DASHBOARD_ROUTE, REWARD_ROUTE, SURVEY_ROUTE } from '../constants';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';

const NAV_ITEMS: { label: string; page: string; icon: ReactElement }[] = [
    {
        label: 'Dashboard',
        page: DASHBOARD_ROUTE.MAIN,
        icon: (
            <DashboardNavIcon/>
        ),
    },
    {
        label: 'Surveys',
        page: SURVEY_ROUTE.MAIN,
        icon: (
            <SurveysNavIcon />
        ),
    },
    {
        label: 'Shop',
        page: REWARD_ROUTE.MAIN,
        icon: (
            <ShopNavIcon/>
        ),
    },
];

interface SidebarProps {
    light?: boolean;
}

const Sidebar = ({ light = false }: SidebarProps) => {
    const auth0 = useAuth0();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const activePage = pathname !== '/' ? pathname : DASHBOARD_ROUTE.MAIN;

    const logout = async () => {
        await auth0.logout({ logoutParams: { returnTo: window.location.origin } });
    };

    const handleClickHome = () => {
        if (activePage !== DASHBOARD_ROUTE.MAIN) {
            navigate(DASHBOARD_ROUTE.HOME);
        }
    };

    return auth0.isAuthenticated && (
        <aside className={`sidebar${light ? ' light-mode' : ''}`}>
            <div className="logo" onClick={handleClickHome}>
                <TheezyIcon light={light}/>
            </div>

            <nav className="nav">
                {NAV_ITEMS.map((item) => (
                    <a
                        key={item.label}
                        href={item.page}
                        className={`nav-item${activePage === item.page ? ' active' : ''}`}
                    >
                        <span className="nav-icon">{item.icon}</span>
                        {item.label}
                    </a>
                ))}
            </nav>

            <div className="sidebar-bottom">
                <button className="logout-btn" onClick={logout}>
                <span className="nav-icon">
                    <AuthActionIcon />
                </span>
                    Logout
                </button>
            </div>
        </aside>
    );
}

export default Sidebar;